<template>
  <div>
    <h1 class="heading text-6xl">{{ time }}</h1>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      time: 5,
      interval: [],
    }
  },

  mounted: function() {
    this.startTimer()
  },

  methods: {
    tick: function() {
      this.time -= 1
      if (this.time <= 0) this.timeOver()
    },

    startTimer: function() {
      this.time = 5

      const tickFunction = this.tick
      this.interval = setInterval(tickFunction, 1000)
    },

    timeOver: function() {
      this.$emit('startGame')
    },
  },
}
</script>
